<template>
  <div class="container">
    <!-- 顶部搜索栏 -->
    <div class="search-bar">
      <div class="search-input-group">
        <el-select v-model="searchType" class="search-type">
          <el-option label="OE" value="OE" />
          <el-option label="VIN" value="VIN" />
          <el-option label="Manufacturer Code" value="BIG" />

        </el-select>
        <el-input
          v-model="searchInput"
          placeholder="Please enter search content..."
          class="search-input"
          @keyup.enter.native="performSearch" />
      </div>
      <el-button
        type="danger"
        class="search-btn"
        :loading="searchLoading"
        @click="performSearch">
        {{ searchLoading ? 'Searching...' : 'Search' }}
      </el-button>
    </div>

    <div class="main-content">
      <!-- 左侧筛选条件 -->
      <div class="filter-panel">
        <h2 class="filter-title">Search Conditions</h2>
        <div class="filter-group">
          <label>Brand Selection</label>
          <el-select
            style="width: 360px"
            v-model="selectedBrand"
            placeholder="Please select a brand"
            @change="onBrandChange"
             :filterable="true"
          >
            <el-option
              v-for="brand in brandList"
              :key="brand.brandId"
              :label="brand.brandName"
              :value="brand.brandId"
            />
          </el-select>
        </div>
        <div class="filter-group">
          <label>Model Range</label>
          <el-select
            style="width: 360px"
            v-model="selectedModel"
            placeholder="Please select a model"
            @change="onModelChange"
            :disabled="!selectedBrand"
            :filterable="true"
          >
            <el-option
              v-for="model in modelList"
              :key="model.modelId"
              :label="model.model + ' ' + model.type +' '+ model.yearFrom + '-' + (model.yearTo === 0 ? '' : model.yearTo)"
              :value="model.modelId"
            />
          </el-select>
        </div>
        <div class="filter-group">
          <label>Engine</label>
          <el-select
            style="width: 360px"
            v-model="selectedEngine"
            placeholder="Please select an engine"
            :disabled="!selectedModel"
            @change="onEngineChange"
            :filterable="true"
          >
            <el-option
              v-for="engine in engineList"
              :key="engine.engineId"
              :label="engine.engineLiters + '(' + engine.engineCode + ')  |  ' + engine.pw + '('+engine.ph+')'"
              :value="engine.engineId"
            />
          </el-select>
        </div>
        <div class="advanced-search">
        <!-- INSERT_YOUR_CODE -->
        <div class="selected-filter-list" style="margin-bottom: 12px;">
          <template v-if="selectedBrand">
            <div >
              <label style="font-weight: 500; color: #333;">Brand:</label>
              <span>{{ getBrandName(selectedBrand) }}</span>
            </div>
          </template>
          <template v-if="selectedModel">
            <div >
              <label style="font-weight: 500; color: #333;">Model Range:</label>
              <span>{{ getModelDisplayName(selectedModel) }}</span>
            </div>
            <div >
              <label style="font-weight: 500; color: #333;">Model Year:</label>
              <span>{{ getModelTimeName(selectedModel) }}</span>
            </div>
          </template>
          <template v-if="selectedEngine">
            <div>
              <label style="font-weight: 500; color: #333;">Engine:</label>
              <span>{{ getEngineDisplayName(selectedEngine) }}</span>
            </div>
            <div>
              <label style="font-weight: 500; color: #333;">Power kW (h.p.):</label>
              <span>{{ getEngineKwName(selectedEngine) }}</span>
            </div>
          </template>
        </div>

        </div>
      </div>

      <!-- 右侧结果区域 -->
      <div class="result-panel">
        <div class="breadcrumb">
          <span class="breadcrumb-item clickable" @click="goToHome">Home</span>
          <span v-if="isSearchMode && showProductList" class="breadcrumb-item">Search Results</span>
          <span v-if="!isSearchMode && !showSubGroup && !showProductList" class="breadcrumb-item">Search Results</span>
          <span v-if="!isSearchMode && (showSubGroup || showProductList)" class="breadcrumb-item clickable" @click="goToMainGroup">{{ currentMainGroup && currentMainGroup.mainGroupName ? currentMainGroup.mainGroupName : 'Engine Parts' }}</span>
          <span v-if="!isSearchMode && showSubGroup && !showProductList" class="breadcrumb-item">Sub Categories</span>
          <span v-if="!isSearchMode && showProductList" class="breadcrumb-item clickable" @click="goToSubGroup">{{ currentSubGroup && currentSubGroup.subGroupName ? currentSubGroup.subGroupName : 'Piston System' }}</span>
          <span v-if="!isSearchMode && showProductList" class="breadcrumb-item">Product List</span>
          <span v-if="isSearchMode && showProductList" class="breadcrumb-item">Product List</span>
        </div>

        <!-- 主分组标题 -->
        <h2 v-if="!isSearchMode && !showSubGroup && !showProductList" class="result-title">Search Result Categories</h2>

        <!-- 搜索结果显示标题 -->
        <h2 v-if="isSearchMode && showProductList" class="result-title">Search Results</h2>

        <!-- 二级分类标题 -->
        <h2 v-if="!isSearchMode && showSubGroup && !showProductList" class="result-title">Sub Categories</h2>

        <!-- 产品列表标题 -->
        <h2 v-if="!isSearchMode && showProductList" class="result-title">Product List</h2>

        <div class="result-cards">


          <!-- 主分组卡片 -->
          <div v-if="!isSearchMode && !showSubGroup && !showProductList && mainGroupList.length > 0" class="result-card" v-for="item in mainGroupList" :key="item.mainGroupId">
            <div class="card-img-placeholder"></div>
            <div class="card-title">{{ item.mainGroupName || 'Engine Parts' }}</div>
            <el-button class="card-btn" type="danger" plain @click="showSubGroupDetail(item)">View Details</el-button>
          </div>

          <!-- 二级分组卡片 -->
          <div v-if="showSubGroup && !showProductList" class="result-card" v-for="item in subGroupList" :key="item.subGroupId">
            <div class="card-img-placeholder"></div>
            <div class="card-title">{{ item.subGroupName || 'Piston System' }}</div>
            <el-button class="card-btn" type="danger" plain @click="showProductList2(item)">View Products</el-button>
          </div>

          <!-- 产品列表 -->
          <div v-if="showProductList" class="product-list-container">
            <el-table :data="productList" style="width: 100%" @row-click="onProductRowClick" :row-class-name="getProductRowClassName">
              <el-table-column label="Picture" width="150">
                <template slot-scope="scope">
                  <img v-if="scope.row.productImage" :src="'https://apc-public.oss-cn-shanghai.aliyuncs.com/partsgopro/img2/' + scope.row.productImage" style="width: 100%; height: 100%; object-fit: cover;">
                </template>     

              </el-table-column>
              <el-table-column prop="apcNo" label="APC No." width="120"></el-table-column>
              <el-table-column prop="description" label="Description" width="200"></el-table-column>
              <el-table-column prop="location" label="Position" width="200"></el-table-column>
              <el-table-column prop="specifications" label="Specification" width="200"></el-table-column>
              <el-table-column label="Operation" width="120">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    class="add-btn"
                    @click.stop="addToInquiry(scope.row)">
                    Add to Inquiry
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination-container">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
                prev-text="Previous"
                next-text="Next">
              </el-pagination>
            </div>
          </div>

          <div v-if="!isSearchMode && mainGroupList.length === 0 && !showSubGroup && !showProductList && selectedEngine" class="empty-tip">No main group data available</div>
          <div v-if="!isSearchMode && mainGroupList.length === 0 && !showSubGroup && !showProductList && !selectedEngine" class="empty-tip">Please select a brand/model/engine to view results</div>
          <div v-if="!isSearchMode && subGroupList.length === 0 && showSubGroup && !showProductList" class="empty-tip">No sub-category data available</div>
        </div>
      </div>
    </div>

    <!-- 询价对话框 -->
    <el-dialog
      title="Inquiry"
      :visible.sync="showInquiryDialog"
      width="500px"
      :before-close="closeInquiryDialog">
      <el-form :model="inquiryForm" label-width="80px">
        <el-form-item label="Name" prop="name" required>
          <el-input v-model="inquiryForm.name" placeholder="Please enter your name"></el-input>
        </el-form-item>
        <el-form-item label="Email" required>
          <el-input v-model="inquiryForm.email" placeholder="Please enter your email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeInquiryDialog">Cancel</el-button>
        <el-button type="primary" @click="submitInquiry">Confirm</el-button>
      </span>
    </el-dialog>

    <!-- OE列表弹框 -->
    <el-dialog
      :visible.sync="showOeDialog"
      width="900px"
      :before-close="closeOeDialog">
      <div class="oe-dialog-content">
        <div class="product-info">
          <h4>Product Information</h4>
<!--          <div class="info-row">
            <span class="label">Brand:</span>
            <span class="value">{{ selectedBrand ? getBrandName(selectedBrand) :' ' }}</span>
          </div>
          <div class="info-row">
            <span class="label">Model Range:</span>
            <span class="value">{{ selectedModel ? getModelDisplayName(selectedModel) :' ' }}</span>
          </div>
          <div class="info-row">
            <span class="label">Model Year:</span>
            <span class="value">{{ selectedModel ? getModelTimeName(selectedModel) :' ' }}</span>
          </div>
          <div class="info-row">
            <span class="label">Engine:</span>
            <span class="value">{{ selectedEngine ? getEngineDisplayName(selectedEngine) :' ' }}</span>
          </div>
          <div class="info-row">
            <span class="label">Power kW (h.p.):</span>
            <span class="value">{{ selectedEngine ? getEngineKwName(selectedEngine) :' ' }}</span>
          </div>-->

          <div class="info-row">
            <span class="label">APC No:</span>
            <span class="value">{{ selectedProduct && selectedProduct.apcNo ? selectedProduct.apcNo : '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">Description:</span>
            <span class="value">{{ selectedProduct && selectedProduct.description ? selectedProduct.description : '-' }}</span>
          </div>
        </div>

        <el-tabs v-model="activeTab" @tab-click="onTabClick" class="oe-tabs">
          <el-tab-pane label="OE" name="oe">
            <el-table :data="oeList" style="width: 100%" v-loading="oeLoading" :stripe="true">
              <el-table-column prop="referenceNumber" label="OE Number" width="300" align="center"></el-table-column>
              <el-table-column prop="brandName" label="Brand" width="300" align="center"></el-table-column>
            </el-table>
            <div v-if="oeList.length === 0 && !oeLoading" class="empty-tip">No OE data available</div>
          </el-tab-pane>
          <el-tab-pane label="Manufacturer Code" name="manufacturer">
            <el-table :data="manufacturerList" style="width: 100%" v-loading="oeLoading" :stripe="true">
              <el-table-column prop="referenceNumber" label="Manufacturer Code" width="300" align="center"></el-table-column>
              <el-table-column prop="brandName" label="Brand" width="300" align="center"></el-table-column>
            </el-table>
            <div v-if="manufacturerList.length === 0 && !oeLoading" class="empty-tip">No manufacturer code data available</div>
          </el-tab-pane>
                     <el-tab-pane label="Application" name="car_tab">
             <CarTab
               ref="carTabComponent"
               :apcNo="selectedProduct ? selectedProduct.apcNo : ''">
             </CarTab>
           </el-tab-pane>
        </el-tabs>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeOeDialog">Close</el-button>
      </span>
    </el-dialog>

    <!-- 询价清单浮动框 -->
    <div class="inquiry-float-panel" :class="{ 'collapsed': isInquiryPanelCollapsed }">
      <div class="inquiry-header">
        <i class="el-icon-money"></i>
        <span>Inquiry List</span>
        <span class="inquiry-count">{{ inquiryList.length }}</span>
        <el-button
          type="text"
          class="collapse-btn"
          @click="toggleInquiryPanel">
          <i :class="isInquiryPanelCollapsed ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </el-button>
      </div>
      <div v-if="!isInquiryPanelCollapsed" class="inquiry-content">
        <div v-if="inquiryList.length === 0" class="inquiry-empty">
          <i class="el-icon-shopping-cart-2"></i>
          <p>Inquiry list is empty</p>
        </div>
        <div v-else class="inquiry-items">
          <div v-for="(item, index) in inquiryList" :key="index" class="inquiry-item">
            <div class="item-info">
              <div class="item-apc">{{ item.apcNo }}</div>
              <div class="item-desc">{{ item.description }}</div>
            </div>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="removeFromInquiry(index)">
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="!isInquiryPanelCollapsed" class="inquiry-footer">
        <el-button
          type="danger"
          size="small"
          :disabled="inquiryList.length === 0"
          @click="openInquiryDialog">
          Submit Inquiry
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import partsApi from '../api/partsApi'
//导入carTab.vue作为子组件
import CarTab from './carTab.vue'

export default {
  name: "PartsSearchPage",
  components: {
    CarTab
  },
  data() {
    return {
      searchType: "OE",
      searchInput: "",
      brandList: [],
      modelList: [],
      engineList: [],
      mainGroupList: [],
      subGroupList: [],
      productList: [],
      oeList: [],
      manufacturerList: [],
      showSubGroup: false,
      showProductList: false,
      currentMainGroup: null,
      currentSubGroup: null,
      activeTab: 'oe',
      selectedBrand: "",
      selectedModel: "",
      selectedEngine: "",
      // 新增搜索相关状态
      isSearchMode: false,
      searchResults: [],
      searchLoading: false,
      // 新增产品选择相关状态
      selectedProduct: null,
      // 新增询价清单相关状态
      inquiryList: [],
      showInquiryDialog: false,
      inquiryForm: {
        email: '',
        name: ''
      },
      // 新增询价清单折叠状态
      isInquiryPanelCollapsed: true,
      // 新增OE列表弹框状态
      showOeDialog: false,
      oeLoading: false,
      // 新增分页相关状态
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  mounted() {
    this.fetchBrands();
  },
  methods: {
    // 执行搜索
    async performSearch() {
      if (!this.searchInput.trim()) {
        this.$message.warning('Please enter search content');
        return;
      }

      this.searchLoading = true;
      this.isSearchMode = true;

      // 搜索时重置分页到第一页
      this.pagination.pageNum = 1;

      try {
        const response = await partsApi.searchProductByOe(
          this.searchInput.trim(),
          this.searchType,
          this.pagination.pageNum,
          this.pagination.pageSize
        );
        if (response.data && response.data.code === 200) {
          this.searchResults = response.data.data.records || [];

          // 如果搜索结果不为空，切换到产品列表页面
          if (this.searchResults.length > 0) {
            this.showSubGroup = false;
            this.showProductList = true;
            this.currentMainGroup = null;
            this.currentSubGroup = null;
            
            // 设置产品列表数据
            this.productList = this.searchResults;
            this.pagination.total = response.data.data.total || 0; // 设置总条数

            // 清空OE列表和大厂号列表，等待获取真正的数据
            this.oeList = [];
            this.manufacturerList = [];

            // 根据搜索类型设置默认标签页
            if (this.searchType === 'OE') {
              this.activeTab = 'oe';
            } else if (this.searchType === 'BIG') {
              this.activeTab = 'manufacturer';
            } else {
              // VIN搜索，默认显示在OE列表中
              this.activeTab = 'oe';
            }

            // 设置第一个产品为选中状态
            if (this.productList.length > 0) {
              this.selectedProduct = this.productList[0];

              // 尝试从搜索结果中提取品牌、车型、发动机信息
              //this.updateFilterFromSearchResults();
            }
            //清空左侧的下拉选
            this.selectedBrand = "";
            this.selectedModel = "";
            this.selectedEngine = "";

            this.$message.success(`Found ${this.pagination.total} related products`);
          } else {
            this.$message.info('No related products found');
          }
        } else {
          this.$message.error(response.data.msg || 'Search failed');
        }
      } catch (error) {
        this.$message.error('Search failed, please try again later');
      } finally {
        this.searchLoading = false;
      }
    },

    // 获取品牌列表
    async fetchBrands() {
      try {
        const response = await partsApi.getBrandList();
        if (response.data && response.data.data) {
          this.brandList = response.data.data.filter(
            (item) => item.type === "车型品牌"
          );
        }
      } catch (error) {
        this.$message.error("Failed to get brand list");
      }
    },
    // 品牌选择变化
    async onBrandChange(brandId) {
      this.selectedModel = "";
      this.selectedEngine = "";
      this.modelList = [];
      this.engineList = [];
      this.mainGroupList = [];
      this.showSubGroup = false;
      this.showProductList = false;
      this.isSearchMode = false; // 重置搜索模式
      this.currentMainGroup = null;
      this.currentSubGroup = null;
      this.subGroupList = [];
      this.productList = [];
      this.searchResults = []; // 清空搜索结果
      this.pagination.total = 0; // 清空总条数
      this.pagination.pageNum = 1; // 重置当前页
      if (brandId) {
        await this.fetchModels(brandId);
      }
    },
    // 获取车型列表
    async fetchModels(brandId) {
      try {
        const response = await partsApi.getModelList(brandId);
        if (response.data && response.data.data) {
          this.modelList = response.data.data;
        }
      } catch (error) {
        this.$message.error("Failed to get model list");
      }
    },
    // 车型选择变化
    async onModelChange(modelId) {
      this.selectedEngine = "";
      this.engineList = [];
      this.mainGroupList = [];
      this.showSubGroup = false;
      this.showProductList = false;
      this.isSearchMode = false; // 重置搜索模式
      this.currentMainGroup = null;
      this.currentSubGroup = null;
      this.subGroupList = [];
      this.productList = [];
      this.searchResults = []; // 清空搜索结果
      this.pagination.total = 0; // 清空总条数
      this.pagination.pageNum = 1; // 重置当前页
      if (modelId && this.selectedBrand) {
        await this.fetchEngines(this.selectedBrand, modelId);
      }
    },
    // 获取发动机列表
    async fetchEngines(brandId, modelId) {
      try {
        const response = await partsApi.getEngineList(brandId, modelId);
        if (response.data && response.data.data) {
          this.engineList = response.data.data;
        }
      } catch (error) {
        this.$message.error("Failed to get engine list");
      }
    },
    // 发动机选择变化
    async onEngineChange(engineId) {
      this.mainGroupList = [];
      this.showSubGroup = false;
      this.showProductList = false;
      this.isSearchMode = false; // 重置搜索模式
      this.currentMainGroup = null;
      this.currentSubGroup = null;
      this.subGroupList = [];
      this.productList = [];
      this.searchResults = []; // 清空搜索结果
      this.pagination.total = 0; // 清空总条数
      this.pagination.pageNum = 1; // 重置当前页
      if (engineId && this.selectedBrand && this.selectedModel) {
        await this.fetchMainGroups(this.selectedBrand, this.selectedModel, engineId);
      }
    },
    // 获取主分组列表
    async fetchMainGroups(brandId, modelId, engineId) {
      try {
        const response = await partsApi.getMainGroup(brandId, modelId, engineId);
        if (response.data && response.data.data) {
          this.mainGroupList = response.data.data.records || response.data.data;
        }
      } catch (error) {
        this.$message.error("Failed to get main group");
      }
    },
    // 获取二级分组列表
    async fetchSubGroups(mainGroupId) {
      try {
        const response = await partsApi.getSubGroup(this.selectedBrand, this.selectedModel, this.selectedEngine, mainGroupId);
        if (response.data && response.data.data) {
          this.subGroupList = response.data.data.records || response.data.data;
        }
      } catch (error) {
        this.$message.error("Failed to get sub-category");
      }
    },
    // 显示二级分组详情
    async showSubGroupDetail(mainGroup) {
      this.currentMainGroup = mainGroup;
      this.showSubGroup = true;
      this.showProductList = false;
      this.subGroupList = [];
      this.productList = [];
      this.pagination.total = 0; // 清空总条数
      this.pagination.pageNum = 1; // 重置当前页

      // 调用新的获取二级分组方法
      await this.fetchSubGroups(mainGroup.mainGroupId);
    },
    // 显示产品列表
    async showProductList2(subGroup) {
      this.currentSubGroup = subGroup;
      this.showProductList = true;
      this.productList = [];
      this.oeList = [];
      this.manufacturerList = [];
      this.pagination.total = 0; // 清空总条数
      this.pagination.pageNum = 1; // 重置当前页

      try {
        const params = {
          brandId: this.selectedBrand,
          modelId: this.selectedModel,
          engineId: this.selectedEngine,
          mainGroupId: this.currentMainGroup.mainGroupId,
          subGroupId: subGroup.subGroupId,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        };

        const response = await partsApi.getProductList(params);
        if (response.data && response.data.data) {
          this.productList = response.data.data.records || [];
          this.pagination.total = response.data.data.total || 0; // 设置总条数

          // 等待产品列表数据加载完成后再获取OE列表
          if (this.productList.length > 0) {
            this.selectedProduct = this.productList[0];
            // 清空OE列表和大厂号列表，等待用户点击产品行时在弹框中显示
            this.oeList = [];
            this.manufacturerList = [];
          } else {
            // 如果没有产品数据，清空相关列表
            this.selectedProduct = null;
            this.oeList = [];
            this.manufacturerList = [];
          }
        }
      } catch (error) {
        this.$message.error("Failed to get product list");
      }
    },
    // 跳转到首页
    goToHome() {
      // 重置所有状态
      this.isSearchMode = false;
      this.showSubGroup = false;
      this.showProductList = false;
      this.currentMainGroup = null;
      this.currentSubGroup = null;
      this.subGroupList = [];
      this.productList = [];
      this.searchResults = [];
      this.oeList = [];
      this.manufacturerList = [];
      this.selectedProduct = null;
      this.pagination.total = 0; // 清空总条数
      this.pagination.pageNum = 1; // 重置当前页

      // 检查当前路由，避免重复导航
      if (this.$route.path !== '/') {
        this.$router.push('/').catch(err => {
          // 忽略重复导航错误
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    // 跳转到主分组
    goToMainGroup() {
      this.showSubGroup = false;
      this.showProductList = false;
      this.currentSubGroup = null;
      this.subGroupList = [];
      this.productList = [];
      this.pagination.total = 0; // 清空总条数
      this.pagination.pageNum = 1; // 重置当前页
    },
    // 跳转到二级分类
    goToSubGroup() {
      this.showProductList = false;
      this.currentSubGroup = null;
      this.productList = [];
      this.pagination.total = 0; // 清空总条数
      this.pagination.pageNum = 1; // 重置当前页
    },
    // 产品行点击事件
    onProductRowClick(row) {
      this.selectedProduct = row;

      // 打开OE列表弹框
      this.openOeDialog();
    },
    // 产品列表行样式
    getProductRowClassName({ row }) {
      return row.apcNo === this.selectedProduct.apcNo ? 'selected-product-row' : '';
    },
    // 加入询价
    addToInquiry(product) {
      // 检查产品是否已经在询价清单中
      const existingProduct = this.inquiryList.find(item => item.apcNo === product.apcNo);
      if (existingProduct) {
        this.$message.warning('This product is already in the inquiry list');
        return;
      }

      // 添加到询价清单
      this.inquiryList.push({
        apcNo: product.apcNo,
        description: product.description,
        location: product.location,
        specifications: product.specifications
      });

      this.$message.success('Product added to inquiry list');
      this.autoExpandInquiryPanel(); // 自动展开询价清单
    },

    // 从询价清单中移除产品
    removeFromInquiry(index) {
      this.inquiryList.splice(index, 1);
      this.$message.success('Product removed from inquiry list');
    },

    // 显示询价对话框
    openInquiryDialog() {
      if (this.inquiryList.length === 0) {
        this.$message.warning('Inquiry list is empty, please add products first');
        return;
      }
      this.showInquiryDialog = true;
    },

    // 关闭询价对话框
    closeInquiryDialog() {
      this.showInquiryDialog = false;
      this.inquiryForm.email = '';
      this.inquiryForm.name = '';
    },

    // 提交询价
    async submitInquiry() {
      if (!this.inquiryForm.name.trim()) {
        this.$message.warning('Please enter your name');
        return;
      }
      if (!this.inquiryForm.email.trim()) {
        this.$message.warning('Please enter your email address');
        return;
      } else {
        // 校验邮箱格式
        const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!emailPattern.test(this.inquiryForm.email.trim())) {
          this.$message.warning('Please enter a valid email format');
          return;
        }
      }

      if (this.inquiryList.length === 0) {
        this.$message.warning('Inquiry list is empty');
        return;
      }

      try {
        const data = {
          apcNos: this.inquiryList.map(item => item.apcNo),
          email: this.inquiryForm.email.trim(),
          name: this.inquiryForm.name.trim()
        };

        const response = await partsApi.submitInquiry(data);
        if (response.data && response.data.code === 200) {
          this.$message.success('Inquiry submitted successfully');
          this.inquiryList = []; // 清空询价清单
          this.isInquiryPanelCollapsed = true; // 自动折叠询价清单
          this.closeInquiryDialog();
        } else {
          this.$message.error(response.data.msg || 'Inquiry submission failed');
        }
      } catch (error) {
        this.$message.error('Inquiry submission failed, please try again later');
      }
    },

    // 获取OE列表
    async fetchOeLists() {
      if (!this.selectedProduct) return;

      this.oeLoading = true; // 开始加载
      try {
        // 获取OE列表
        const oeResponse = await partsApi.getOeList('OE', this.selectedProduct.apcNo);
        if (oeResponse.data && oeResponse.data.code === 200) {
          this.oeList = oeResponse.data.data || [];
        } else {
          this.oeList = [];
        }

        // 获取大厂号列表
        const bigResponse = await partsApi.getOeList('BIG', this.selectedProduct.apcNo);
        if (bigResponse.data && bigResponse.data.code === 200) {
          this.manufacturerList = bigResponse.data.data || [];
        } else {
          this.manufacturerList = [];
        }
      } catch (error) {
        // 在弹框中显示时，不显示错误提示，只记录日志
        this.$message.error("Failed to get OE list, please try again later");
        // 清空列表，避免显示错误数据
        this.oeList = [];
        this.manufacturerList = [];
      } finally {
        this.oeLoading = false; // 结束加载
      }
    },

    // 标签页切换事件
    onTabClick() {
      // 当切换tab时，重新获取对应的数据
      if (this.selectedProduct) {
        this.fetchOeLists();

        // 如果切换到Car Tab，刷新发动机数据
        if (this.activeTab === 'car_tab' && this.$refs.carTabComponent) {
          this.$nextTick(() => {
            this.$refs.carTabComponent.reloadData();
          });
        }
      }
    },

    // 折叠/展开询价清单
    toggleInquiryPanel() {
      this.isInquiryPanelCollapsed = !this.isInquiryPanelCollapsed;
    },

    // 自动展开询价清单（当有产品加入时）
    autoExpandInquiryPanel() {
      if (this.isInquiryPanelCollapsed) {
        this.isInquiryPanelCollapsed = false;
      }
    },

    // 尝试从搜索结果中提取品牌、车型、发动机信息
    /*updateFilterFromSearchResults() {
      if (this.searchResults.length > 0) {
        const firstResult = this.searchResults[0];

        // 如果搜索结果中包含品牌、车型、发动机信息，则更新筛选条件
        if (firstResult.brandId && firstResult.modelId && firstResult.engineId) {
          // 异步更新筛选条件
          this.$nextTick(async () => {
            try {
              // 更新品牌选择
              if (firstResult.brandId !== this.selectedBrand) {
                this.selectedBrand = firstResult.brandId;
                await this.fetchModels(firstResult.brandId);
              }

              // 更新车型选择
              if (firstResult.modelId !== this.selectedModel) {
                this.selectedModel = firstResult.modelId;
                await this.fetchEngines(firstResult.brandId, firstResult.modelId);
              }

              // 更新发动机选择
              if (firstResult.engineId !== this.selectedEngine) {
                this.selectedEngine = firstResult.engineId;
              }
            } catch (error) {
              console.error('Failed to update filter conditions:', error);
            }
          });
        }
      }
    },*/

    // 打开OE列表弹框
    openOeDialog() {
      this.showOeDialog = true;
      this.activeTab = 'oe'; // 默认打开OE列表
      this.fetchOeLists(); // 加载数据
    },

    // 关闭OE列表弹框
    closeOeDialog() {
      this.showOeDialog = false;
      this.oeList = [];
      this.manufacturerList = [];
      this.activeTab = 'oe'; // 确保关闭时回到OE列表
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1; // 切换页码时重置当前页
      this.loadProductList(); // 重新获取数据
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.loadProductList(); // 重新获取数据
    },

    // 加载产品列表数据（分页专用）
    async loadProductList() {
      if (this.isSearchMode) {
        // 如果是搜索模式，只更新分页参数重新搜索
        await this.loadSearchResults();
      } else if (this.showProductList && this.currentSubGroup) {
        // 如果是通过筛选条件显示的产品列表，只更新分页参数重新获取数据
        await this.loadFilteredProducts();
      }
    },

    // 加载搜索结果（分页专用）
    async loadSearchResults() {
      try {
        const response = await partsApi.searchProductByOe(
            this.searchInput.trim(),
            this.searchType,
            this.pagination.pageNum,
            this.pagination.pageSize
        );
        if (response.data && response.data.code === 200) {
          this.searchResults = response.data.data.records || [];
          this.productList = this.searchResults;
          this.pagination.total = response.data.data.total || 0;

          // 更新选中产品
          if (this.productList.length > 0) {
            this.selectedProduct = this.productList[0];
          }
        }
      } catch (error) {
        this.$message.error('Failed to load data, please try again later');
      }
    },

    // 加载筛选产品（分页专用）
    async loadFilteredProducts() {
      try {
        const params = {
          brandId: this.selectedBrand,
          modelId: this.selectedModel,
          engineId: this.selectedEngine,
          mainGroupId: this.currentMainGroup.mainGroupId,
          subGroupId: this.currentSubGroup.subGroupId,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        };

        const response = await partsApi.getProductList(params);
        if (response.data && response.data.data) {
          this.productList = response.data.data.records || [];
          this.pagination.total = response.data.data.total || 0;

          // 更新选中产品
          if (this.productList.length > 0) {
            this.selectedProduct = this.productList[0];
          }
        }
      } catch (error) {
        this.$message.error('Failed to load data, please try again later');
      }
    },

    // 刷新产品列表数据（保留原有方法，用于其他场景）
    async refreshProductList() {
      if (this.isSearchMode) {
        // 如果是搜索模式，重新执行搜索
        await this.performSearch();
      } else if (this.showProductList && this.currentSubGroup) {
        // 如果是通过筛选条件显示的产品列表，重新获取数据
        await this.showProductList2(this.currentSubGroup);
      }
    },

    // 获取品牌名称
    getBrandName(brandId) {
      const brand = this.brandList.find(b => b.brandId === brandId);
      return brand ? brand.brandName : '';
    },

    // 获取车型显示名称
    getModelDisplayName(modelId) {
      const model = this.modelList.find(m => m.modelId === modelId);
      if (!model) return '';
      return `${model.model} ${model.type}`;
    },
     // 获取车型年份显示名称
     getModelTimeName(modelId) {
      const model = this.modelList.find(m => m.modelId === modelId);
      if (!model) return '';
      return `${model.yearFrom}-${model.yearTo === 0 ? '' : model.yearTo}`;
    },

    // 获取发动机显示名称
    getEngineDisplayName(engineId) {
      const engine = this.engineList.find(e => e.engineId === engineId);
      if (!engine) return '';
      return `${engine.engineLiters}(${engine.engineCode})`;
    },
    // 获取发动机功率显示名称
    getEngineKwName(engineId) {
      const engine = this.engineList.find(e => e.engineId === engineId);
      if (!engine) return '';
      return `${engine.pw}(${engine.ph})`;
    }
  },
};
</script>

<style scoped>
.container {
  padding: 24px;
  background: #f7f8fa;
  min-height: 100vh;
}

/* 顶部搜索栏样式 */
.search-bar {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px #0000000d;
  margin-bottom: 24px;
}

.search-input-group {
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 8px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
}

.search-type {
  width: 120px;
  border: none;
  border-radius: 0;
}

.search-type .el-input__inner {
  border: none;
  border-radius: 0;
  background: #f5f7fa;
  color: #606266;
  font-weight: 500;
}

.search-input {
  flex: 1;
  border: none;
  border-radius: 0;
}

.search-input .el-input__inner {
  border: none;
  border-radius: 0;
  border-left: 1px solid #e4e7ed;
}

.search-btn {
  width: 125px;
  border-radius: 8px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(231, 76, 60, 0.3);
  padding-left: 14px
;
}

/* 主内容区域 */
.main-content {
  display: flex;
  gap: 24px;
}

/* 左侧筛选面板 */
.filter-panel {
  width: 400px;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px #0000000d;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filter-title {
  font-size: 22px;
  font-weight: bold;
  color: #223255;
  margin-bottom: 16px;
}

.filter-group {
  margin-bottom: 12px;
}

.filter-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}



.advanced-link {
  color: #e74c3c;
  cursor: pointer;
}

/* 右侧结果面板 */
.result-panel {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px #0000000d;
}

/* 面包屑导航 */
.breadcrumb {
  color: #888;
  font-size: 14px;
  margin-bottom: 12px;
}

.breadcrumb span + span::before {
  content: " > ";
  margin: 0 4px;
}

.breadcrumb span.clickable + span::before {
  content: " > ";
  margin: 0 4px;
}

.breadcrumb span:not(.clickable) + span::before {
  content: "";
  margin: 0;
}

.breadcrumb-item {
  cursor: pointer;
  color: #888;
  font-size: 14px;
  transition: color 0.3s ease;
}

.breadcrumb-item.clickable {
  color: #000;
  text-decoration: none;
}

.breadcrumb-item.clickable:hover {
  color: #333;
  text-decoration: none;
}

.breadcrumb-item:not(.clickable) {
  cursor: default;
}

/* 结果标题 */
.result-title {
  font-size: 22px;
  font-weight: bold;
  color: #223255;
  margin-bottom: 24px;
}

/* 结果卡片区域 */
.result-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;
}

.result-card {
  background: #fafbfc;
  border-radius: 12px;
  padding: 32px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 1px 4px #0000000a;
  min-height: 200px;
  width: 100%;
}

.card-img-placeholder {
  width: 80px;
  height: 80px;
  background: #fdeaea;
  border-radius: 50%;
  margin-bottom: 16px;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
  color: #223255;
  margin-bottom: 16px;
  text-align: center;
}

.card-btn {
  width: 120px;
}

/* 空状态提示 */
.empty-tip {

}

/* 产品列表容器 */
.product-list-container {
  width: 100%;
}

.oe-tabs {
  margin-top: 24px;
}

/* 搜索结果容器样式*/
.search-results-container {
  background: #fafbfc;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px #0000000d;
  margin-bottom: 24px;
}

/* 产品列表行选中样式 */
.selected-product-row {
  background-color: #f0f9eb; /* 浅绿色背景 */
  font-weight: bold;
}

/* 询价清单浮动框样式 */
.inquiry-float-panel {
  position: fixed;
  right: 20px;
  /* bottom: 180px; */
  top: 100px;
  width: 300px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  transition: all 0.3s ease;
  overflow: hidden;
}

.inquiry-header {
  background: #223255;
  color: #fff;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  position: relative;
}

.inquiry-header i {
  font-size: 18px;
  color: #ffd700;
}

.inquiry-count {
  background: #e74c3c;
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-left: auto;
  margin-right: 8px;
}

.inquiry-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 16px;
}

.inquiry-empty {
  text-align: center;
  color: #999;
  padding: 40px 20px;
}

.inquiry-empty i {
  font-size: 48px;
  margin-bottom: 16px;
  display: block;
}

.inquiry-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.inquiry-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.item-info {
  flex: 1;
  margin-right: 12px;
}

.item-apc {
  font-weight: 500;
  color: #223255;
  margin-bottom: 4px;
}

.item-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.inquiry-footer {
  padding: 16px 20px;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

.inquiry-footer .el-button {
  width: 100%;
}

/* OE弹框样式 */
.oe-dialog-content {
  padding: 0px 0px 20px 0px;
  margin-top: -18px;
}

.product-info {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 6px;
}

.product-info h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
}

.info-row {
  display: flex;
  margin-bottom: 10px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-row .label {
  width: 120px;
  font-weight: 500;
  color: #606266;
}

.info-row .value {
  flex: 1;
  color: #303133;
}

.oe-tabs {
  margin-top: 20px;
}

/* 询价清单折叠状态样式 */
.inquiry-float-panel.collapsed {
  height: auto;
}

.inquiry-float-panel.collapsed .inquiry-content,
.inquiry-float-panel.collapsed .inquiry-footer {
  display: none;
}

/* 折叠按钮样式 */
.collapse-btn {
  margin-left: auto;
  color: #fff;
  padding: 0;
  font-size: 16px;
}

.collapse-btn:hover {
  color: #ffd700;
}

.collapse-btn i {
  transition: transform 0.3s ease;
}

/* 询价清单展开/折叠动画 */
.inquiry-float-panel {
  transition: all 0.3s ease;
}

.inquiry-content,
.inquiry-footer {
  transition: opacity 0.3s ease;
}

/* 选中产品行样式 */
.selected-product-row {
  background-color: #f0f9ff !important;
}

.selected-product-row:hover {
  background-color: #e0f2fe !important;
}

/* 空数据提示样式 */
.empty-tip {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 16px;
  width: 420px;
}

/* 分页组件样式 */
.pagination-container {
  margin-top: 20px;
  text-align: center;
  padding: 20px 0;
}

.pagination-container .el-pagination {
  justify-content: center;
}

/* 高级搜索选项样式 */
.advanced-search {
  padding: 0px 0px 10px 5px;
}

.advanced-link {
  font-weight: 500;
  color: #495057;
  margin-bottom: 15px;
  display: block;
}

.selected-filter-list {
  margin-top: 15px;
}

.selected-filter-list > div {
  margin-bottom: 8px;
}

.selected-filter-list > div:last-child {
  margin-bottom: 0;
}

.selected-filter-list label {
  margin-right: 8px;
  font-weight: 500;
  color: #495057;
}

.selected-filter-list span {
  color: #6c757d;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .result-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }

  .filter-panel {
    width: 100%;
  }

  .result-cards {
    grid-template-columns: 1fr;
  }
  .add-btn{
    width: 140px;
  }
}
</style>
